export const sortItemsByLabel = (items: {
    id?: number;
    label: string;
    public?: boolean,
    value?: string | number
}[]) => {
    return [ ...items ].sort((a, b) => {
        // Ensure both items have 'label' and handle undefined values gracefully
        if (a.label && b.label) {
            return a.label.localeCompare(b.label);
        }
        return 0; // If 'label' is missing in either, don't change order
    });
};